import React, {useEffect, useState} from 'react';
import {Grid} from "@mui/material";
import PreviousNextButton from "../../../../../components/PreviousNextButton";
import {useIntl} from "react-intl";
import {Formats} from "../../../../../constants/Formats";
import dayjs from "dayjs";
import AreaSelectDialog from "./AreaSelectDialog";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {DictItemDto} from "../../../../../modules/dict/dto/DictItemDto";
import {AreaDto} from "../../../../../modules/vms/dto/AreaDto";
import {RequestPlaceDto} from "../../../../../modules/vms/dto/RequestPlaceDto";
import {useConfirm} from "material-ui-confirm";
import FormFieldText from "../../../../../components/FormFieldText";
import FormFieldDate from "../../../../../components/FormFieldDate";
import FormFieldTime from "../../../../../components/FormFieldTime";


import {VisitorAccessLogDto} from "../../../../../modules/vms/dto/VisitorAccessLogDto";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import {SiteDto} from "../../../../../modules/vms/dto/SiteDto";
import {SiteApi} from "../../../../../modules/vms/api/SiteApi";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import FormFieldSelect from "../../../../../components/FormFieldSelect";
import {VMSCacheKey} from "../../../../../modules/vms/constants/VMSCacheKey";
import {RequestVisitorApi} from "../../../../../modules/vms/api/RequestVisitorApi";

export type RegisterRequestFormProps = {
    visitRequest: VisitRequestDto;
    requestVisitor: RequestVisitorDto;
    purposeTypes: Array<DictItemDto>;
    onChange: (name: string, value: any) => void;
    onNext: () => void;
    onPrevious: () => void;
    onChangeMapValue: (changeValues: Map<string, any>) => void;
    onVisitorChange: (name: string, value: any) => void;
};
const RegisterRequestForm: React.FC<RegisterRequestFormProps> = (props) => {
    const intl = useIntl();
    const confirm = useConfirm();
    const [messageMap, setMessageMap] = useState(new Map<string, string>());

    // 场所选择的对话框
    const [areaSelectDialogOpen, setAreaSelectDialogOpen] = useState(false);

    // 选择的场所显示字符串
    const [selectedPlaceStr, setSelectedPlaceStr] = useState('');

    // 站点列表
    const [sites, setSites] = useState(new Array<SiteDto>());
    // 站点key: site id, Value: Site对象
    const [siteMap, setSiteMap] = useState(new Map<string, SiteDto>());

    useEffect(() => {
        const placeString = props.visitRequest?.places.map(item => item.areaName).join(",");
        setSelectedPlaceStr(placeString);

        // 查询访问站点
        fetchSiteList();
    }, []);

    const fetchSiteList = async () => {
        const responseResult = await SiteApi.getSiteList();
        if (responseResult.status === HttpStatus.SUCCESS) {
            if (responseResult.data.length > 0) {
                setSites(responseResult.data);

                // 默认选中第一个站点
                const defaultSite = responseResult.data[0];
                const changeValues = new Map<string, any>();
                changeValues.set("siteId", defaultSite.id)
                changeValues.set("siteName", defaultSite.name);
                changeValues.set("siteCode", defaultSite.code);
                props.onChangeMapValue(changeValues);
            }
        }
    };
    const checkCardNumber = async (cardNumber: string) => {
        if (cardNumber === "") {
            return true;
        }
        if (cardNumber) {
            const responseResult = await RequestVisitorApi.doCheckVisitorCardNumber(cardNumber, props.visitRequest.id);
            if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
                if (responseResult.data === true) {
                    return true;
                }
            }
        }
        return false;
    };
    const handleNext = async () => {
        if (validate()) {
            if (await checkCardNumber(props.requestVisitor.accessCardNumber)) {
                props.onNext();
            } else {
                confirm({title: intl.formatMessage({id: 'VMS_VISITOR_CARD_NUMBER_USED_WARNING'})})
                    .then(async () => {
                        // props.onNext();
                    })
                    .catch(() => {
                        console.log('cancel');
                    });

            }
        }
    }

    const handlePrevious = () => {
        props.onPrevious();
    }

    const handleVisitorChange = (name: string, value: any) => {
        props.onVisitorChange(name, value);
    };
    const handleChange = (name: string, value: any) => {
        props.onChange(name, value);
    };

    const handleChangeSiteId = (siteId: string) => {
        let siteDtos = sites.filter(site => site.id === siteId);
        const changeValues = new Map<string, any>();
        changeValues.set("siteId", siteId)
        if (siteDtos.length > 0) {
            const site = siteDtos[0];
            // localStorage.setItem(VMSCacheKey.VISIT_REQUEST_SITE_ID, siteId);
            // localStorage.setItem(VMSCacheKey.VISIT_REQUEST_SITE_NAME, site.name);
            changeValues.set("siteName", site.name);
            changeValues.set("siteCode", site.code);
        }

        props.onChangeMapValue(changeValues);


    }
    const validate = () => {
        const newMessageMap = new Map<string, string>();

        // if (props.visitRequest.places.length <= 0) {
        //     newMessageMap.set('places', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PLACES_REQUIRED'}));
        // }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    const handleSelectAreas = (areas: Array<AreaDto>) => {
        const places = new Array<RequestPlaceDto>();
        for (let area of areas) {
            const place = new RequestPlaceDto(area);
            places.push(place);
        }
        handleChange("places", places);
        const selectedPlaceStr = areas.map((area) => {
            return area.name
        }).join(',')

        setSelectedPlaceStr(selectedPlaceStr);
        setAreaSelectDialogOpen(false);
    }
    const checkInLog = props.requestVisitor.checkInLog && Object.assign(new VisitorAccessLogDto(), props.requestVisitor.checkInLog);


    return (
        <div>
            <AreaSelectDialog open={areaSelectDialogOpen} onCancel={() => setAreaSelectDialogOpen(false)}
                              onOk={handleSelectAreas}/>
            {/*<Alert severity={"warning"}>*/}
            {/*    <FormattedMessage id={'VMS_VISIT_REQUEST_REGISTER_STEP_HOST_INFO_ALERT'}/>*/}
            {/*</Alert>*/}
            <Grid container spacing={2} style={{height: '60vh'}}>


                <Grid item xs={3}>
                    <FormFieldDate label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_START_DATE"})}
                                   required={true} errorText={messageMap.get("arriveStartDate")}
                                   value={dayjs(props.visitRequest.arriveStartDate, Formats.DATE_SIMPLE)}
                                   minDate={dayjs()}
                                   maxDate={dayjs().add(15, "days")}
                                   onChange={(value) => handleChange("arriveStartDate", value)}/>
                </Grid>
                <Grid item xs={3}>
                    <FormFieldTime label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_START_TIME"})}
                                   required={true} errorText={messageMap.get("arriveStartTime")}
                                   value={dayjs(props.visitRequest.arriveStartTime, Formats.TIME_SIMPLE)}
                        // minTime={dayjs()}
                        // maxTime={dayjs().add(15, "days")}
                                   onChange={(value) => handleChange("arriveStartTime", value)}/>
                </Grid>
                <Grid item xs={3}>
                    <FormFieldDate label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_END_DATE"})}
                                   required={true} errorText={messageMap.get("arriveEndDate")}
                                   value={dayjs(props.visitRequest.arriveEndDate, Formats.DATE_SIMPLE)}
                                   minDate={props.visitRequest.arriveStartDate !== "" ? dayjs(props.visitRequest.arriveStartDate, Formats.DATE_SIMPLE) : dayjs()}
                                   maxDate={(props.visitRequest.arriveStartDate !== "" ? dayjs(props.visitRequest.arriveStartDate, Formats.DATE_SIMPLE) : dayjs()).add(2, "days")}
                                   onChange={(value) => handleChange("arriveEndDate", value)}/>
                </Grid>
                <Grid item xs={3}>
                    <FormFieldTime label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_END_TIME"})}
                                   required={true} errorText={messageMap.get("arriveEndTime")}
                                   value={dayjs(props.visitRequest.arriveEndTime, Formats.TIME_SIMPLE)}
                        // minTime={dayjs()}
                        // maxTime={dayjs().add(15, "days")}
                                   onChange={(value) => handleChange("arriveEndTime", value)}/>
                </Grid>
                <Grid item xs={6}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER"})}
                                   placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_PLACEHOLDER"})}
                                   value={props.requestVisitor.accessCardNumber}
                                   onChange={(value) => {
                                       handleVisitorChange("accessCardNumber", value)
                                   }}/>
                </Grid>

                <Grid item xs={6}>
                    <FormFieldSelect label={intl.formatMessage({id: "VMS_VISIT_REQUEST_SITE"})}
                                     errorText={messageMap.get("siteId")}
                                     value={props.visitRequest.siteId}
                                     onChange={(value) => {
                                         handleChangeSiteId(value)
                                     }}
                                     items={sites.map((item) => {
                                         return {label: item.name, value: item.id}
                                     })}/>
                </Grid>
                <Grid item xs={6}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PURPOSE"})}
                                   value={props.visitRequest.purpose}
                                   onChange={(value) => {
                                       handleChange("purpose", value)
                                   }}/>
                </Grid>
                <Grid item xs={6}>
                    <FormFieldText label={intl.formatMessage({id: "COMMON_REMARKS"})}
                                   value={props.visitRequest.remarks}
                                   onChange={(value) => {
                                       handleChange("remarks", value)
                                   }}/>
                </Grid>
                {/*<Grid item xs={6}>*/}
                {/*    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PLACE"})}*/}
                {/*                   disabled={true} errorText={messageMap.get("places")}*/}
                {/*                   value={props.visitRequest.places && props.visitRequest.places.map(item => item.areaName).join(",")}*/}
                {/*                   endAdornment={*/}
                {/*                       <Badge badgeContent={props.visitRequest.places.length} color="secondary"*/}
                {/*                              overlap="rectangular">*/}
                {/*                           <Button color="primary"*/}
                {/*                                   onClick={() => setAreaSelectDialogOpen(true)}>*/}
                {/*                               <FormattedMessage id="VMS_VISIT_REQUEST_PLACE_SELECT"/>*/}
                {/*                           </Button>*/}
                {/*                       </Badge>}/>*/}
                {/*</Grid>*/}


                {/*<Grid item xs={6}>*/}
                {/*    <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_CHECKIN_TIME"})}*/}
                {/*                   disabled={true}*/}
                {/*                   value={checkInLog?.fetchAccessDateTime()}*/}
                {/*    />*/}
                {/*</Grid>*/}

            </Grid>
            <Grid>
                <PreviousNextButton onPrevious={handlePrevious} onNext={() => handleNext()}/>
            </Grid>
        </div>
    );
};

export default RegisterRequestForm;
